'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { useId } from 'react';
import { FieldFooter } from '../../atoms/field-footer';
import { ExclamationMarkTriangleXs } from '../../icons/symbols/exclamation-mark-triangle-xs';
import styles from './textarea.module.scss';
const defaultOnInvalid = (e)=>e.preventDefault();
export const Textarea = ({ centered, className, 'data-testid': testId, errorMessage, footer, forcedError, inputClassName, label, onInvalid = defaultOnInvalid, placeholder = ' ', ...props })=>{
    const id = useId();
    const labelId = `${id}-label`;
    const footerId = footer ? `${id}-footer` : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.wrapper, className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs("label", {
                className: classNames(className, styles['field-wrapper']),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames(styles.label, centered && styles['label-centered']),
                        id: labelId,
                        children: label
                    }),
                    /*#__PURE__*/ _jsx("textarea", {
                        ...props,
                        "aria-labelledby": [
                            labelId,
                            footerId
                        ].join(' '),
                        className: classNames(inputClassName, styles.input, centered && styles['input-centered']),
                        onInvalid: onInvalid,
                        placeholder: placeholder
                    })
                ]
            }),
            forcedError ? /*#__PURE__*/ _jsx(FieldFooter, {
                className: classNames(styles['error-message'], styles['forced-error']),
                "data-testid": "field-error",
                error: true,
                icon: /*#__PURE__*/ _jsx(ExclamationMarkTriangleXs, {}),
                children: forcedError
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    footer && /*#__PURE__*/ _jsx(FieldFooter, {
                        className: classNames(styles.footer),
                        "data-testid": "field-footer",
                        id: footerId,
                        children: footer
                    }),
                    errorMessage && /*#__PURE__*/ _jsx(FieldFooter, {
                        className: styles['error-message'],
                        "data-testid": "field-error",
                        error: true,
                        icon: /*#__PURE__*/ _jsx(ExclamationMarkTriangleXs, {}),
                        children: errorMessage
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=index.js.map